import React from 'react';

export const iconHeaderLogo = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="40"
        height="24"
        viewBox="0 0 40 24"
    >
        <defs>
            <path id="a" d="M0 .057h39.788v23.911H0z" />
            <path id="c" d="M0 .048h34.345v23.91H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <mask id="b" fill="#fff">
                <use xlinkHref="#a" />
            </mask>
            <path
                fill="#FFF"
                d="M28.067 23.968a11.557 11.557 0 01-7.964-3.185L15.8 16.86a6.206 6.206 0 01-4.088 1.547c-3.457 0-6.27-2.868-6.27-6.394 0-3.526 2.813-6.395 6.27-6.395a6.19 6.19 0 014.21 1.656l.018.017.102.093.044.043 1.81 1.648a.74.74 0 01.041.035l6.716 6.104a.84.84 0 01.05.049 4.55 4.55 0 003.363 1.476c2.555 0 4.634-2.12 4.634-4.726s-2.079-4.727-4.634-4.727a4.6 4.6 0 00-3.448 1.57l-1.217-1.115a6.225 6.225 0 014.665-2.123c3.457 0 6.27 2.869 6.27 6.395 0 3.526-2.813 6.394-6.27 6.394a6.153 6.153 0 01-4.526-1.97l-6.65-6.044a.836.836 0 01-.042-.037L14.952 8.63a.773.773 0 01-.045-.044l-.03-.028a4.57 4.57 0 00-3.164-1.271c-2.555 0-4.634 2.12-4.634 4.726s2.079 4.726 4.634 4.726a4.601 4.601 0 003.454-1.576.806.806 0 011.154-.066l4.877 4.447.012.01a9.945 9.945 0 006.857 2.746c5.561 0 10.086-4.615 10.086-10.287 0-5.673-4.525-10.287-10.086-10.287-2.864 0-5.604 1.25-7.517 3.43l-1.219-1.113C21.554 1.51 24.738.057 28.067.057c3.131 0 6.074 1.244 8.288 3.502 2.214 2.258 3.433 5.26 3.433 8.454 0 3.193-1.219 6.195-3.433 8.453-2.214 2.258-5.157 3.502-8.288 3.502"
                mask="url(#b)"
            />
            <mask id="d" fill="#fff">
                <use xlinkHref="#c" />
            </mask>
            <path
                fill="#FFF"
                d="M11.72 1.716c-5.56 0-10.084 4.615-10.084 10.287 0 5.673 4.524 10.287 10.085 10.287a9.996 9.996 0 006.945-2.83l-2.864-2.603a6.207 6.207 0 01-4.081 1.541c-3.457 0-6.27-2.869-6.27-6.395 0-3.526 2.813-6.394 6.27-6.394 1.726 0 3.332.7 4.526 1.97l6.65 6.044.043.037 1.896 1.726c.016.014.03.03.045.045l.03.028.034.029a4.57 4.57 0 003.13 1.242c2.556 0 4.634-2.12 4.634-4.727 0-2.606-2.078-4.726-4.634-4.726a4.601 4.601 0 00-3.454 1.577.807.807 0 01-1.154.065l-4.865-4.436a9.944 9.944 0 00-6.88-2.766m-.001 22.242c-3.131 0-6.074-1.244-8.288-3.502C1.219 18.2 0 15.197 0 12.003 0 8.81 1.22 5.808 3.433 3.55 5.647 1.292 8.59.048 11.72.048a11.557 11.557 0 017.959 3.18l4.307 3.928a6.207 6.207 0 014.088-1.547c3.457 0 6.27 2.868 6.27 6.394 0 3.526-2.813 6.395-6.27 6.395a6.184 6.184 0 01-4.21-1.656l-.018-.017-.102-.093a.769.769 0 01-.044-.043l-1.81-1.647a.938.938 0 01-.041-.035l-6.716-6.105a.827.827 0 01-.05-.049 4.55 4.55 0 00-3.363-1.476c-2.555 0-4.634 2.12-4.634 4.726 0 2.607 2.079 4.727 4.634 4.727a4.6 4.6 0 003.448-1.57.807.807 0 011.153-.065l4.07 3.7a.845.845 0 01.065 1.179c-2.223 2.532-5.407 3.985-8.736 3.985"
                mask="url(#d)"
            />
        </g>
    </svg>
);

export const iconBrokeChain = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                fill="#AAA"
                d="M21.33 7.268l-4.14 4.137c-.37.376-1.04.375-1.41.001l-.88-.879 1.8-1.8-1.41-1.414-1.8 1.8-.87-.866a.98.98 0 0 1-.29-.707c0-.269.1-.52.29-.707l4.14-4.139a1.002 1.002 0 0 1 1.41 0l3.16 3.159c.39.391.39 1.025 0 1.415zm-9.5 8.085c.39.391.39 1.025 0 1.415l-4.14 4.137c-.37.376-1.04.375-1.41.001l-3.16-3.159a.98.98 0 0 1-.29-.707c0-.269.1-.52.29-.707l4.14-4.139a1.002 1.002 0 0 1 1.41 0l.87.867-2.25 2.252 1.41 1.414 2.25-2.252.88.878zM22.75 4.439l-3.16-3.158c-1.13-1.131-3.12-1.131-4.24 0l-4.14 4.137a2.964 2.964 0 0 0-.88 2.122c0 .803.31 1.557.88 2.122l.86.865-1.12 1.119-.86-.865c-1.13-1.131-3.12-1.131-4.24 0l-4.14 4.137a2.964 2.964 0 0 0-.88 2.122c0 .803.31 1.557.88 2.122l3.16 3.159a2.96 2.96 0 0 0 2.12.876c.8 0 1.55-.312 2.12-.877l4.14-4.138a3.022 3.022 0 0 0 0-4.243l-.88-.878 1.12-1.12.88.88a2.96 2.96 0 0 0 2.12.876c.8 0 1.55-.312 2.12-.877l4.14-4.138a3.022 3.022 0 0 0 0-4.243zM19 17.021h3v-2h-3zm-3 5h2v-3h-2zm-14-13h3v-2H2zm4-4h2v-3H6z"
            />
        </g>
    </svg>
);

export const iconChainRed = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                fill="#E52020"
                d="M21.33 7.268l-4.14 4.137c-.37.376-1.04.375-1.41.001l-.88-.879 1.8-1.8-1.41-1.414-1.8 1.8-.87-.866a.98.98 0 0 1-.29-.707c0-.269.1-.52.29-.707l4.14-4.139a1.002 1.002 0 0 1 1.41 0l3.16 3.159c.39.391.39 1.025 0 1.415zm-9.5 8.085c.39.391.39 1.025 0 1.415l-4.14 4.137c-.37.376-1.04.375-1.41.001l-3.16-3.159a.98.98 0 0 1-.29-.707c0-.269.1-.52.29-.707l4.14-4.139a1.002 1.002 0 0 1 1.41 0l.87.867-2.25 2.252 1.41 1.414 2.25-2.252.88.878zM22.75 4.439l-3.16-3.158c-1.13-1.131-3.12-1.131-4.24 0l-4.14 4.137a2.964 2.964 0 0 0-.88 2.122c0 .803.31 1.557.88 2.122l.86.865-1.12 1.119-.86-.865c-1.13-1.131-3.12-1.131-4.24 0l-4.14 4.137a2.964 2.964 0 0 0-.88 2.122c0 .803.31 1.557.88 2.122l3.16 3.159a2.96 2.96 0 0 0 2.12.876c.8 0 1.55-.312 2.12-.877l4.14-4.138a3.022 3.022 0 0 0 0-4.243l-.88-.878 1.12-1.12.88.88a2.96 2.96 0 0 0 2.12.876c.8 0 1.55-.312 2.12-.877l4.14-4.138a3.022 3.022 0 0 0 0-4.243z"
            />
        </g>
    </svg>
);

export const iconChainBlue = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                fill="#3377BB"
                d="M21.33 7.268l-4.14 4.137c-.37.376-1.04.375-1.41.001l-.88-.879 1.8-1.8-1.41-1.414-1.8 1.8-.87-.866a.98.98 0 0 1-.29-.707c0-.269.1-.52.29-.707l4.14-4.139a1.002 1.002 0 0 1 1.41 0l3.16 3.159c.39.391.39 1.025 0 1.415zm-9.5 8.085c.39.391.39 1.025 0 1.415l-4.14 4.137c-.37.376-1.04.375-1.41.001l-3.16-3.159a.98.98 0 0 1-.29-.707c0-.269.1-.52.29-.707l4.14-4.139a1.002 1.002 0 0 1 1.41 0l.87.867-2.25 2.252 1.41 1.414 2.25-2.252.88.878zM22.75 4.439l-3.16-3.158c-1.13-1.131-3.12-1.131-4.24 0l-4.14 4.137a2.964 2.964 0 0 0-.88 2.122c0 .803.31 1.557.88 2.122l.86.865-1.12 1.119-.86-.865c-1.13-1.131-3.12-1.131-4.24 0l-4.14 4.137a2.964 2.964 0 0 0-.88 2.122c0 .803.31 1.557.88 2.122l3.16 3.159a2.96 2.96 0 0 0 2.12.876c.8 0 1.55-.312 2.12-.877l4.14-4.138a3.022 3.022 0 0 0 0-4.243l-.88-.878 1.12-1.12.88.88a2.96 2.96 0 0 0 2.12.876c.8 0 1.55-.312 2.12-.877l4.14-4.138a3.022 3.022 0 0 0 0-4.243z"
            />
        </g>
    </svg>
);

export const iconLink = (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path fill="#37B" d="M11 6V4H2v18h18v-9h-2v7H4V6h7" />
            <path fill="#37B" d="M22 8.926V2h-7v2h3.586l-7.293 7.292 1.415 1.414L20 5.414v3.512h2" />
        </g>
    </svg>
);

export const iconInfoTooltip = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <path fill="#9299A2" fillOpacity=".01" d="M0 0h20v20H0z" />
            <path
                className="color"
                fill="#37B"
                d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zM9 15h2v-2H9v2zm0-3h2V5H9v7z"
            />
        </g>
    </svg>
);

export const iconInfoTooltipGrey = (
    <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" fill="#9299a2" fillOpacity=".01" />
            <path
                className="color"
                d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zM9 15h2v-2H9zm0-3h2V5H9z"
                fill="#aaa"
            />
        </g>
    </svg>
);

export const iconPrint = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path fill="#AAA" d="M18 3v7H6V8h5V3h7zm-9 .414V6H6.41L9 3.414zM4 12h16V1H8.59L4 5.586V12z" />
            <path
                fill="#AAA"
                d="M21 19v2H3v-2c-.55 0-1-.448-1-1v-5c0-.551.45-1 1-1h18c.55 0 1 .449 1 1v5c0 .552-.45 1-1 1zM3 10c-1.65 0-3 1.346-3 3v5c0 1.655 1.35 3 3 3h18c1.65 0 3-1.345 3-3v-5c0-1.654-1.35-3-3-3H3z"
            />
            <path fill="#AAA" fillRule="nonzero" d="M6 17v4h12v-4H6zm-2-2h16v8H4v-8z" />
        </g>
    </svg>
);

export const iconDownload = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path className="color" fill="#AAA" fillRule="nonzero" d="M22 22H1v-8h2v6h18v-6h2v8h-1z" />
            <path
                className="color"
                fill="#AAA"
                d="M11 11.694L7.35 8.049 5.94 9.462l6.12 6.116 6.11-6.116-1.41-1.413L13 11.804V.021h-2z"
            />
        </g>
    </svg>
);

export const iconPlay = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" transform="translate(-210 -390)">
            <g fill="#FFF" transform="translate(210 390)">
                <rect width="24" height="24" fill="none" rx="1" />
                <path d="M9 8.33l7.873 4.17L9 16.67z" />
            </g>
            <rect width="46" height="46" x="199" y="379" stroke="#EFF5FA" strokeWidth="2" rx="23" />
        </g>
    </svg>
);

export const iconScrollUp = (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
        <g fill="none" fillRule="evenodd">
            <rect width="48" height="48" fill="#EFF5FA" rx="24" />
            <path fill="none" d="M12 12h24v24H12z" />
            <path
                fill="#37B"
                d="M25.003 18.479l2.293 2.31 1.419-1.41-4.677-4.709-4.738 4.704 1.411 1.419 2.292-2.277v14.502h2z"
            />
        </g>
    </svg>
);

export const iconBackBtn = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path fill="none" d="M0 24V0h24v24z" />
            <path
                fill="#37B"
                d="M6.479 10.997l2.31-2.293-1.41-1.419-4.709 4.677L7.374 16.7l1.419-1.411-2.277-2.292h14.502v-2z"
            />
        </g>
    </svg>
);

export const iconSwitchFilters = (
    <svg width="17" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 18">
        <g transform="translate(0 1)" fillRule="nonzero" stroke="#333" fill="none">
            <path d="M.8 2H16M.8 8H16M.8 14H16" strokeLinecap="square" />
            <circle fill="#EFF5FA" cx="12.4" cy="2" r="2" />
            <circle fill="#EFF5FA" cx="4.4" cy="8" r="2" />
            <circle fill="#EFF5FA" cx="12.4" cy="14" r="2" />
        </g>
    </svg>
);

export const iconErrorTooltip = (
    <svg height="20" width="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" fill="#9299a2" fillOpacity=".01" />
            <path
                d="M10 7.879l-1.19-1.19a1.5 1.5 0 1 0-2.12 2.122L7.878 10l-1.19 1.19a1.5 1.5 0 0 0 2.122 2.12L10 12.122l1.19 1.19a1.5 1.5 0 0 0 2.12-2.122L12.122 10l1.19-1.19a1.5 1.5 0 0 0-2.122-2.12zM20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10z"
                fill="#e01f19"
            />
        </g>
    </svg>
);

export const iconSuccessTooltip = (
    <svg height="20" width="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" fill="#9299a2" fillOpacity=".01" />
            <path
                d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zM7.134 9.116a1.25 1.25 0 0 0-1.768 1.768l2.5 2.5c.44.44 1.136.49 1.634.116l5-5a1.25 1.25 0 0 0-1.5-2l-4.133 4.35z"
                fill="#39b54a"
            />
        </g>
    </svg>
);

export const iconHelp = (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                d="M12 22C6.487 22 2 17.515 2 12 2 6.486 6.487 2 12 2c5.514 0 10 4.486 10 10 0 5.515-4.486 10-10 10zm0-22C5.383 0 0 5.384 0 12c0 6.617 5.383 12 12 12 6.618 0 12-5.383 12-12 0-6.616-5.382-12-12-12z"
                fill="#37B"
            />
            <path
                d="M11 17h1v-5h-1v5zm3-5v-2H8v2h1v7h6v-2h-1v-5zM11.5 6a.5.5 0 11-.002 1.002A.5.5 0 0111.5 6zm0 3C12.879 9 14 7.879 14 6.5 14 5.122 12.879 4 11.5 4A2.503 2.503 0 009 6.5C9 7.879 10.122 9 11.5 9z"
                fill="#37B"
            />
        </g>
    </svg>
);

export const iconProfile = (
    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path d="M-1 0h20v20H-1z" />
            <path
                d="M2.333 15.833A4.17 4.17 0 016.5 11.667h5a4.17 4.17 0 014.167 4.166H2.333zm15 0A5.84 5.84 0 0011.5 10h-5a5.84 5.84 0 00-5.833 5.833V17.5h16.666v-1.667zM6.5 5c0-1.378 1.125-2.5 2.5-2.5s2.5 1.122 2.5 2.5c0 1.38-1.125 2.5-2.5 2.5S6.5 6.38 6.5 5zm6.667 0A4.17 4.17 0 009 .833 4.17 4.17 0 004.833 5 4.17 4.17 0 009 9.167 4.17 4.17 0 0013.167 5z"
                fill="#37B"
            />
        </g>
    </svg>
);

export const iconInfoMob = (
    <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
        <g fill="#37B" fillRule="evenodd">
            <rect width="72" height="72" fillOpacity=".08" rx="36" />
            <path d="M35 47h2V37h-2v10zm6-10v-4H29v4h2v14h12v-4h-2V37zm-5-12a1 1 0 110 2 1 1 0 010-2zm0 6c2.758 0 5-2.242 5-5 0-2.756-2.242-5-5-5-2.756 0-5 2.244-5 5 0 2.758 2.244 5 5 5z" />
        </g>
    </svg>
);

export const iconInfoDesktop = (
    <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h120v120H0z" />
            <rect width="120" height="120" fill="#37B" fillOpacity=".08" rx="60" />
            <path
                fill="#37B"
                d="M56 80h4V60h-4v20zm12-20v-8H44v8h4v28h24v-8h-4V60zM58 36a2 2 0 11-2 2c0-1.1.9-2 2-2zm0 12c5.516 0 10-4.484 10-10 0-5.512-4.484-10-10-10-5.512 0-10 4.488-10 10 0 5.516 4.488 10 10 10z"
            />
        </g>
    </svg>
);

export const iconPinUp = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path fill="transparent" d="M-104-104h289v230h-289z" />
            <path
                fill="#37B"
                d="M14.135 5.948l3.917 3.916-6.347 6.35-3.731-4.105 6.161-6.161zM3.209 21.999l5.995-5.995 3.872 4.258 1.265-1.149-1.487-1.635 6.406-6.405 1.531 1.53L22 11.396 12.604 2l-1.208 1.208 1.531 1.531-6.104 6.105L5.8 9.717l-1.265 1.15 3.52 3.871L2 20.791 3.209 22z"
            />
        </g>
    </svg>
);

export const iconPinIn = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <path fill="transparent" d="M-150-104h289v230h-289z" />
            <path
                fill="#B2CCE5"
                d="M3.209 22l5.995-5.996 3.872 4.258 1.265-1.149-1.487-1.635 6.406-6.405 1.531 1.53L22 11.396 12.604 2l-1.208 1.208 1.531 1.531-6.104 6.105L5.8 9.717l-1.265 1.15 3.52 3.871L2 20.791z"
            />
        </g>
    </svg>
);

export const iconSearch = (
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path
            className="color"
            d="M19.755 18.58l-4.808-4.809A8.431 8.431 0 008.429 0 8.428 8.428 0 000 8.429a8.428 8.428 0 008.429 8.428 8.384 8.384 0 005.338-1.906l4.809 4.804a.833.833 0 001.18-1.175zM8.43 15.18c-3.727 0-6.756-3.029-6.756-6.751A6.763 6.763 0 018.43 1.673c3.722 0 6.755 3.033 6.755 6.756 0 3.722-3.033 6.75-6.755 6.75z"
            fill="#333"
            fillRule="nonzero"
        />
    </svg>
);

export const iconCheck = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13">
        <path
            className="color"
            fill="#333"
            fillRule="evenodd"
            d="M4.421 9.693l-2.733-2.68L0 8.666 4.421 13 16 1.653 14.312 0l-9.89 9.693"
        />
    </svg>
);

export const iconCheckBold = (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
        <path
            fill="#FFF"
            fillRule="evenodd"
            d="M3.24 4.59L1.846 3.283.31 4.713 3.24 7.45l6.174-5.77L7.879.25 3.24 4.59"
        />
    </svg>
);

export const iconArrow = (
    <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
        <path
            className="color"
            d="M.006 8.755L1.24 10l4.999-4.948L1.245 0 0 1.233l3.764 3.806L.006 8.755"
            fill="#37B"
            fillRule="evenodd"
        />
    </svg>
);

export const iconArrowMob = (
    <svg width="8" height="8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8">
        <path d="M0 .993L3.959 5 8 .998 7.014 0 3.969 3.017.996.005z" fill="#333" fillRule="evenodd" />
    </svg>
);

export const iconCross = (color) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
        <path
            className="color"
            fill={color || "#37B"}
            fillRule="evenodd"
            d="M5 3.585L1.465.05.051 1.464 3.586 5 .051 8.536 1.465 9.95 5 6.414 8.536 9.95 9.95 8.536 6.415 5 9.95 1.464 8.536.05z"
        />
    </svg>
);

export const iconClose = (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
        <g fill="#FFF" fillRule="evenodd">
            <path className="color" d="M1.84.25l15.91 15.91-1.59 1.59L.25 1.84z" />
            <path className="color" d="M16.16.25L.25 16.16l1.59 1.59L17.75 1.84z" />
        </g>
    </svg>
);

export const iconStar = (color = "#909090") => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 21 21">
        <g fill="none" fillRule="evenodd">
            <path d="M-1-2h24v24H-1z" />
            <path
                className="color"
                fill={color}
                d="M6.155 9.945h3.652l1.129-3.474 1.129 3.474h3.651l-1.779 1.293-1.175.853.448 1.382.68 2.091-1.778-1.292-1.176-.854-2.955 2.146.68-2.091.448-1.382-1.175-.853-1.779-1.293zM4.178 20.8l6.758-4.91 6.757 4.91-2.58-7.945 6.758-4.91h-8.353L10.936 0 8.354 7.945H0l6.758 4.91-2.58 7.945z"
            />
        </g>
    </svg>
);

export const iconStarFilled = (
    <svg width="22" height="22" fill="none" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
        <path
            className="color"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.178 20.8l6.758-4.91 6.757 4.91-2.58-7.945 6.758-4.91h-8.353L10.936 0 8.354 7.945H0l6.758 4.91-2.58 7.945z"
            fill="#37B"
        />
    </svg>
);

export const iconLogout = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path
                className="color"
                fill="#AAA"
                d="M14 14h-2v3c0 .55-.448 1-1 1H3c-.551 0-1-.45-1-1V3c0-.55.449-1 1-1h8c.552 0 1 .45 1 1v3h2V3c0-1.65-1.345-3-3-3H3C1.346 0 0 1.35 0 3v14c0 1.65 1.346 3 3 3h8c1.655 0 3-1.35 3-3v-3z"
            />
            <path className="color" fill="#AAA" d="M7 9.09V11h8.04v3.09l4.041-4.04L15.04 6v3.09z" />
        </g>
    </svg>
);

export const iconThumbUp = (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
        <g fill="none" fillRule="evenodd">
            <path fill="none" d="M0-.667h20v20H0z" />
            <path
                fill="#909090"
                className="color"
                d="M1.667 10.947a.66.66 0 0 1 .658-.659h1.854a.66.66 0 0 1 .659.659v5.828a.658.658 0 0 1-.659.657H2.325a.659.659 0 0 1-.658-.657v-5.828zm4.837-.375c.294-.199.645-.52.958-1.038.189-.312.549-.846.929-1.409.887-1.32 1.32-1.978 1.461-2.32.281-.683.39-1.53.29-2.267a90.49 90.49 0 0 1-.203-1.676c.09-.017.21-.029.368-.029.435 0 1.498 1.254 1.498 2.896 0 1.587-.195 2.04-.188 2.03a.835.835 0 0 0 .701 1.282h5.16a.708.708 0 0 1 0 1.415h-.83a.833.833 0 1 0 0 1.666h1.159c.39 0 .706.317.706.706a.708.708 0 0 1-.333.595 2.364 2.364 0 0 0-.523-.246.835.835 0 0 0-.251-.04h-1.447a.834.834 0 0 0 0 1.667h1.294a.694.694 0 0 1 .314.31.696.696 0 0 1 .046.54.694.694 0 0 1-.49.47 2.351 2.351 0 0 0-.604-.302.825.825 0 0 0-.25-.039h-1.24a.833.833 0 1 0 0 1.667h1.085a.705.705 0 0 1 .363.85.688.688 0 0 1-.682.493h-7.44a4.246 4.246 0 0 1-1.85-.843v-6.378zM4.18 19.1c.614 0 1.168-.242 1.584-.632 1.183.825 2.378.98 2.437.987.03.004.063.006.094.006h7.497a2.365 2.365 0 0 0 2.308-2.955c.513-.288.918-.76 1.104-1.348.149-.47.145-.961 0-1.421a2.38 2.38 0 0 0 .977-1.908c0-.681-.288-1.296-.75-1.729.267-.384.422-.85.422-1.35a2.377 2.377 0 0 0-2.374-2.375H13.38c.054-.416.092-.953.092-1.645 0-2.345-1.539-4.562-3.165-4.562-1.467 0-1.909.7-2.009.915a.818.818 0 0 0-.073.445s.177 1.592.266 2.237c.059.443-.011.996-.18 1.406-.105.244-.826 1.315-1.303 2.024-.397.59-.773 1.148-.971 1.477-.149.244-.295.39-.404.476-.4-.324-.901-.525-1.454-.525H2.325A2.328 2.328 0 0 0 0 10.947v5.828a2.326 2.326 0 0 0 2.325 2.324h1.854z"
            />
        </g>
    </svg>
);

export const iconSettings = (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
        <path
            fill="#37B"
            fillRule="evenodd"
            d="M5 7.143a2.142 2.142 0 1 1 0-4.286c1.184 0 2.143.957 2.143 2.143S6.183 7.143 5 7.143zm2.977-4.107L9.041 1.97 8.03.957 6.967 2.021A3.513 3.513 0 0 0 5.714 1.5V0H4.286v1.5a3.515 3.515 0 0 0-1.252.521L1.97.957.96 1.971l1.063 1.065c-.248.371-.43.793-.522 1.25H0v1.428h1.5c.094.457.275.879.523 1.25L.959 8.03l1.01 1.014 1.064-1.064c.375.25.798.428 1.253.521V10h1.428V8.5a3.513 3.513 0 0 0 1.253-.521l1.064 1.064 1.01-1.014L7.977 6.97c.249-.378.43-.8.523-1.257H10V4.286H8.5a3.495 3.495 0 0 0-.523-1.25z"
        />
    </svg>
);

export const iconThumbDown = (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
        <g fill="none" fillRule="evenodd">
            <path fill="none" d="M0 20.667h20v-20H0z" />
            <path
                fill="#909090"
                className="color"
                d="M1.667 9.053a.66.66 0 0 0 .658.659h1.854a.66.66 0 0 0 .659-.659V3.225a.658.658 0 0 0-.659-.657H2.325a.659.659 0 0 0-.658.657v5.828zm4.837.375c.294.199.645.52.958 1.038.189.312.549.846.929 1.409.887 1.32 1.32 1.978 1.461 2.32.281.683.39 1.53.29 2.267a90.49 90.49 0 0 0-.203 1.676c.09.017.21.029.368.029.435 0 1.498-1.254 1.498-2.896 0-1.587-.195-2.04-.188-2.03a.835.835 0 0 1 .701-1.282h5.16a.708.708 0 0 0 0-1.415h-.83a.833.833 0 1 1 0-1.666h1.159c.39 0 .706-.317.706-.706a.708.708 0 0 0-.333-.595c-.163.1-.335.187-.523.246a.835.835 0 0 1-.251.04h-1.447a.834.834 0 0 1 0-1.667h1.294a.694.694 0 0 0 .314-.31.696.696 0 0 0 .046-.54.694.694 0 0 0-.49-.47 2.351 2.351 0 0 1-.604.302.825.825 0 0 1-.25.039h-1.24a.833.833 0 1 1 0-1.667h1.085a.705.705 0 0 0 .363-.85.688.688 0 0 0-.682-.493h-7.44a4.246 4.246 0 0 0-1.85.843v6.378zM4.18.9c.614 0 1.168.242 1.584.632C6.946.708 8.141.553 8.2.546A.714.714 0 0 1 8.294.54h7.497a2.365 2.365 0 0 1 2.308 2.955c.513.288.918.76 1.104 1.348.149.47.145.961 0 1.421a2.38 2.38 0 0 1 .977 1.908c0 .681-.288 1.296-.75 1.729.267.384.422.85.422 1.35a2.377 2.377 0 0 1-2.374 2.375H13.38c.054.416.092.953.092 1.645 0 2.345-1.539 4.562-3.165 4.562-1.467 0-1.909-.7-2.009-.915a.818.818 0 0 1-.073-.445s.177-1.592.266-2.237c.059-.443-.011-.996-.18-1.406-.105-.244-.826-1.315-1.303-2.024a44.413 44.413 0 0 1-.971-1.477 1.768 1.768 0 0 0-.404-.476c-.4.324-.901.525-1.454.525H2.325A2.328 2.328 0 0 1 0 9.053V3.225A2.326 2.326 0 0 1 2.325.901h1.854z"
            />
        </g>
    </svg>
);

export const iconEye = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="15" viewBox="0 0 24 15">
        <g className="color" fill="#AAA" fillRule="evenodd">
            <path d="M12.005 2.101c3.27 0 6.475 1.796 9.31 5.204-2.835 3.408-6.04 5.202-9.31 5.202-3.28 0-6.485-1.794-9.309-5.202 2.824-3.408 6.03-5.204 9.31-5.204zm0 12.508c4.161 0 8.142-2.304 11.507-6.666L24 7.305l-.488-.637C20.147 2.306 16.166 0 12.005 0 7.834 0 3.853 2.306.5 6.668L0 7.305l.499.637c3.354 4.363 7.335 6.667 11.506 6.667z" />
            <path d="M12.049 5.217c1.148 0 2.087.937 2.087 2.087 0 1.151-.94 2.087-2.087 2.087a2.091 2.091 0 0 1-2.087-2.087c0-1.15.94-2.087 2.087-2.087zm0 6.261a4.175 4.175 0 0 0 4.174-4.174c0-2.3-1.868-4.174-4.174-4.174a4.176 4.176 0 0 0-4.174 4.174 4.175 4.175 0 0 0 4.174 4.174z" />
        </g>
    </svg>
);

export const iconPencil = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24">
        <g fill="#AAA" fillRule="evenodd">
            <path d="M17.09 5.415L16 6.5l-2.59-2.585 1.09-1.086 2.59 2.586zm-13.68 8.5L12 5.329l2.59 2.586L6 16.5l-2.59-2.585zm-1.41 4v-2.586l2.59 2.586H2zm-2 2h5.41l14.5-14.5L14.5 0 0 14.5v5.415zM0 24h20v-2H0z" />
        </g>
    </svg>
);

export const iconUploadFile = (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
        <g fill="none" fillRule="evenodd">
            <path fillRule="nonzero" d="M-1-1h24v24H-1z" />
            <path
                className="color"
                fill="#37B"
                d="M9.599 0v11.45L7.414 9.27 6 10.68l4.678 4.68 4.677-4.68-1.414-1.41-2.342 2.34V0h-2"
            />
            <path
                className="color"
                fill="#37B"
                d="M0 10.68c0 5.98 4.866 10.84 10.847 10.84 5.98 0 10.846-4.86 10.846-10.84 0-5.35-3.897-9.8-9-10.68v2.03c3.994.85 7 4.4 7 8.65 0 4.87-3.968 8.84-8.846 8.84S2 15.55 2 10.68c0-4.14 2.854-7.61 6.693-8.57V.05C3.741 1.05 0 5.43 0 10.68"
            />
        </g>
    </svg>
);

export const iconHunburger = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18">
        <g className="color" fill="#37B" fillRule="evenodd">
            <path d="M0 0h20v2H0zM0 16h20v2H0zM0 8h20v2H0z" />
        </g>
    </svg>
);

export const iconInfoEmpty = (
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="21" cy="21" r="20" stroke="#3377BB" strokeWidth="2" />
        <path
            d="M17.5474 12.2716C17.3877 10.5148 18.771 9 20.5351 9H21.4649C23.229 9 24.6123 10.5148 24.4526 12.2716L23.4537 23.2592C23.3383 24.5283 22.2743 25.5 21 25.5C19.7257 25.5 18.6617 24.5283 18.5463 23.2592L17.5474 12.2716Z"
            fill="#FFFF75"
        />
        <path
            d="M17.5474 12.2716C17.3877 10.5148 18.771 9 20.5351 9H21.4649C23.229 9 24.6123 10.5148 24.4526 12.2716L23.4537 23.2592C23.3383 24.5283 22.2743 25.5 21 25.5C19.7257 25.5 18.6617 24.5283 18.5463 23.2592L17.5474 12.2716Z"
            fill="#3377BB"
        />
        <rect x="18.75" y="28.5" width="4.5" height="4.5" rx="2.25" fill="#FFFF75" />
        <rect x="18.75" y="28.5" width="4.5" height="4.5" rx="2.25" fill="#3377BB" />
    </svg>
);

export const iconRunning = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 7.23426L16.8725 12.0009L9 16.7676L9 7.23426Z" fill="#3377BB" className="color" />
    </svg>
);

export const iconCheckMarging = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.86223 12.7877L8.02375 11.0448L6 12.9508L9.86223 16.601L18 8.90696L15.9762 7.00098L9.86223 12.7877Z"
            fill="#3377BB"
            className="color"
        />
    </svg>
);

export const iconCloseMarging = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.1819 11.818L6.99985 8.63597L9.12117 6.51465L12.3032 9.69671L15.4853 6.51465L17.6066 8.63597L14.4245 11.818L17.6064 14.9999L15.4851 17.1213L12.3032 13.9393L9.12132 17.1213L7 14.9999L10.1819 11.818Z"
            fill="#3377BB"
            className="color"
        />
    </svg>
);

export const iconClock = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16ZM8 14.4C11.5346 14.4 14.4 11.5346 14.4 8C14.4 4.46538 11.5346 1.6 8 1.6C4.46538 1.6 1.6 4.46538 1.6 8C1.6 11.5346 4.46538 14.4 8 14.4ZM11.8524 10.5803C12.1365 10.1623 11.9981 9.6119 11.5431 9.35087L8.94247 7.85873V3.89224C8.94247 3.39947 8.50763 3 7.97124 3C7.43484 3 7 3.39947 7 3.89224V8.35344C7 8.66118 7.17262 8.94719 7.45675 9.11021L10.5141 10.8644C10.9691 11.1254 11.5683 10.9982 11.8524 10.5803Z"
            fill="#3377BB"
            className="color"
        />
    </svg>
);

export const iconBell = (
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 1.10193C9.23168 1.56377 10.9091 3.54054 10.9091 5.90909V9.75L12 11.5V13H0V11.5L1.09091 9.75V5.90909C1.09091 3.54054 2.76832 1.56377 5 1.10193V1C5 0.447715 5.44772 0 6 0C6.55228 0 7 0.447716 7 1V1.10193ZM8 14C8 15.1046 7.10457 16 6 16C4.89543 16 4 15.1046 4 14H8Z"
            fill="white"
            className="color"
        />
    </svg>
);

export const iconBellDigest = (color = "#464A53") => (
    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0097 18H6.00966C6.00966 19.104 6.89966 20 8.00966 20C9.10966 20 10.0097 19.104 10.0097 18ZM0.109661 15.915C0.229661 16.225 0.669661 16.945 2.01966 16.951H14.0097C15.3497 16.951 15.7897 16.229 15.9097 15.918C16.0697 15.529 16.1997 14.738 15.2497 13.815L15.0097 13.579V9C15.0097 5.479 12.3897 2.564 8.99966 2.079V0.979C8.99966 0.438 8.55966 0 8.01966 0C7.47966 0 7.03966 0.438 7.03966 0.979V2.074C3.63966 2.546 1.00966 5.468 1.00966 9V13.588L0.769661 13.814C-0.170339 14.736 -0.0503393 15.526 0.109661 15.915Z"
            fill={color}
        />
    </svg>
);

export const iconComment = (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 4.586V16V18L13 16H0V0H16V4.586ZM2 11H10V9H2V11ZM14 7H2V5H14V7Z"
            fill="#909090"
            className="color"
        />
    </svg>
);

export const iconArrowSeparator = (
    <svg width="14" height="32" viewBox="0 0 14 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.08301 15.999C0.806865 15.999 0.583008 16.2229 0.583008 16.499C0.583008 16.7752 0.806865 16.999 1.08301 16.999V15.999ZM13.4366 16.8526C13.6318 16.6573 13.6318 16.3407 13.4366 16.1455L10.2546 12.9635C10.0593 12.7682 9.74274 12.7682 9.54747 12.9635C9.35221 13.1588 9.35221 13.4753 9.54747 13.6706L12.3759 16.499L9.54747 19.3275C9.35221 19.5227 9.35221 19.8393 9.54747 20.0346C9.74274 20.2298 10.0593 20.2298 10.2546 20.0346L13.4366 16.8526ZM1.08301 16.999H13.083V15.999H1.08301V16.999Z"
            fill="#3377BB"
        />
    </svg>
);

export const fileIcons = {
    rtf: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">
            <g fill="none" fillRule="evenodd">
                <path fill="none" d="M0 0h24v20H0z" />
                <path
                    className="color"
                    fill="#37B"
                    d="M4.032 12.304h1.696V14H4.032v-1.696zM12.48 14h-1.792c-.096-.288-.16-.464-.16-1.376v-1.76c0-1.04-.352-1.424-1.152-1.424h-.608V14h-1.76V2.8h2.656c1.824 0 2.608.848 2.608 2.576v.88c0 1.152-.368 1.904-1.152 2.272.88.368 1.168 1.216 1.168 2.384v1.728c0 .544.016.944.192 1.36zM9.616 4.4h-.848v3.44h.688c.656 0 1.056-.288 1.056-1.184V5.552c0-.8-.272-1.152-.896-1.152zm3.312 0V2.8h5.44v1.6h-1.84V14h-1.76V4.4h-1.84zm7.968 0v3.376h2.272v1.6h-2.272V14h-1.76V2.8h4.656v1.6h-2.896z"
                />
            </g>
        </svg>
    ),
    pdf: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">
            <g fill="none" fillRule="evenodd">
                <path fill="none" d="M0 0h24v20H0z" />
                <path
                    className="color"
                    fill="#37B"
                    d="M3.52 12.304h1.696V14H3.52v-1.696zM9.088 2.8c1.76 0 2.624.976 2.624 2.768v1.456c0 1.792-.864 2.768-2.624 2.768h-.832V14h-1.76V2.8h2.592zm0 1.6h-.832v3.792h.832c.56 0 .864-.256.864-1.056v-1.68c0-.8-.304-1.056-.864-1.056zm3.52 9.6V2.8h2.784c1.76 0 2.624.976 2.624 2.768v5.664c0 1.792-.864 2.768-2.624 2.768h-2.784zm2.752-9.6h-.992v8h.992c.56 0 .896-.288.896-1.088V5.488c0-.8-.336-1.088-.896-1.088zm5.536 0v3.376h2.272v1.6h-2.272V14h-1.76V2.8h4.656v1.6h-2.896z"
                />
            </g>
        </svg>
    ),    
    xlsx: (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="20" viewBox="0 0 24 20">
            <g fill="none" fillRule="evenodd">
                <path fill="none" d="M0 0h28v20H0z" />
                <path
                    className="color"
                    fill="#37B"
                    d="M.496 12.304h1.696V14H.496v-1.696zM7.712 2.8h1.632l-1.84 5.44L9.472 14H7.616l-1.44-4.432L4.72 14H3.072L5.04 8.24 3.2 2.8h1.824l1.328 4.128L7.712 2.8zm2.64 11.2V2.8h1.76v9.6h2.896V14h-4.656zm5.2-8.512c0-1.792.88-2.816 2.592-2.816 1.712 0 2.592 1.024 2.592 2.816v.352h-1.664v-.464c0-.8-.32-1.104-.88-1.104s-.88.304-.88 1.104c0 2.304 3.44 2.736 3.44 5.936 0 1.792-.896 2.816-2.624 2.816-1.728 0-2.624-1.024-2.624-2.816v-.688h1.664v.8c0 .8.352 1.088.912 1.088s.912-.288.912-1.088c0-2.304-3.44-2.736-3.44-5.936zM26 2.8h1.632l-1.84 5.44L27.76 14h-1.856l-1.44-4.432L23.008 14H21.36l1.968-5.76-1.84-5.44h1.824l1.328 4.128L26 2.8z"
                />
            </g>
        </svg>
    ),    
    doc: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">
            <g fill="none" fillRule="evenodd">
                <path fill="none" d="M0-1h24v20H0z" />
                <path
                    className="color"
                    fill="#37B"
                    d="M2.624 12.304H4.32V14H2.624v-1.696zM5.6 14V2.8h2.784c1.76 0 2.624.976 2.624 2.768v5.664c0 1.792-.864 2.768-2.624 2.768H5.6zm2.752-9.6H7.36v8h.992c.56 0 .896-.288.896-1.088V5.488c0-.8-.336-1.088-.896-1.088zm5.392.976v6.048c0 .8.352 1.104.912 1.104s.912-.304.912-1.104V5.376c0-.8-.352-1.104-.912-1.104s-.912.304-.912 1.104zm-1.76 5.936V5.488c0-1.792.944-2.816 2.672-2.816 1.728 0 2.672 1.024 2.672 2.816v5.824c0 1.792-.944 2.816-2.672 2.816-1.728 0-2.672-1.024-2.672-2.816zm9.92-1.488h1.664v1.488c0 1.792-.896 2.816-2.624 2.816-1.728 0-2.624-1.024-2.624-2.816V5.488c0-1.792.896-2.816 2.624-2.816 1.728 0 2.624 1.024 2.624 2.816v1.088h-1.664v-1.2c0-.8-.352-1.104-.912-1.104s-.912.304-.912 1.104v6.048c0 .8.352 1.088.912 1.088s.912-.288.912-1.088v-1.6z"
                />
            </g>
        </svg>
    ),
    docx: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">
            <g fill="none" fillRule="evenodd">
                <path fill="none" d="M0-1h24v20H0z" />
                <path
                    className="color"
                    fill="#37B"
                    d="M2.624 12.304H4.32V14H2.624v-1.696zM5.6 14V2.8h2.784c1.76 0 2.624.976 2.624 2.768v5.664c0 1.792-.864 2.768-2.624 2.768H5.6zm2.752-9.6H7.36v8h.992c.56 0 .896-.288.896-1.088V5.488c0-.8-.336-1.088-.896-1.088zm5.392.976v6.048c0 .8.352 1.104.912 1.104s.912-.304.912-1.104V5.376c0-.8-.352-1.104-.912-1.104s-.912.304-.912 1.104zm-1.76 5.936V5.488c0-1.792.944-2.816 2.672-2.816 1.728 0 2.672 1.024 2.672 2.816v5.824c0 1.792-.944 2.816-2.672 2.816-1.728 0-2.672-1.024-2.672-2.816zm9.92-1.488h1.664v1.488c0 1.792-.896 2.816-2.624 2.816-1.728 0-2.624-1.024-2.624-2.816V5.488c0-1.792.896-2.816 2.624-2.816 1.728 0 2.624 1.024 2.624 2.816v1.088h-1.664v-1.2c0-.8-.352-1.104-.912-1.104s-.912.304-.912 1.104v6.048c0 .8.352 1.088.912 1.088s.912-.288.912-1.088v-1.6z"
                />
            </g>
        </svg>
    ),
    DOCX: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">
            <g fill="none" fillRule="evenodd">
                <path fill="none" d="M0-1h24v20H0z" />
                <path
                    className="color"
                    fill="#37B"
                    d="M2.624 12.304H4.32V14H2.624v-1.696zM5.6 14V2.8h2.784c1.76 0 2.624.976 2.624 2.768v5.664c0 1.792-.864 2.768-2.624 2.768H5.6zm2.752-9.6H7.36v8h.992c.56 0 .896-.288.896-1.088V5.488c0-.8-.336-1.088-.896-1.088zm5.392.976v6.048c0 .8.352 1.104.912 1.104s.912-.304.912-1.104V5.376c0-.8-.352-1.104-.912-1.104s-.912.304-.912 1.104zm-1.76 5.936V5.488c0-1.792.944-2.816 2.672-2.816 1.728 0 2.672 1.024 2.672 2.816v5.824c0 1.792-.944 2.816-2.672 2.816-1.728 0-2.672-1.024-2.672-2.816zm9.92-1.488h1.664v1.488c0 1.792-.896 2.816-2.624 2.816-1.728 0-2.624-1.024-2.624-2.816V5.488c0-1.792.896-2.816 2.624-2.816 1.728 0 2.624 1.024 2.624 2.816v1.088h-1.664v-1.2c0-.8-.352-1.104-.912-1.104s-.912.304-.912 1.104v6.048c0 .8.352 1.088.912 1.088s.912-.288.912-1.088v-1.6z"
                />
            </g>
        </svg>
    ),
    jpg: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">
            <g fill="none" fillRule="evenodd">
                <path fill="none" d="M0-1h24v20H0z" />
                <path
                    className="color"
                    fill="#37B"
                    d="M5.296 12.304h1.696V14H5.296v-1.696zM7.792 14v-1.6c.192.016.416.016.608.016.56 0 1.008-.208 1.008-1.072V2.8h1.76v8.416c0 2.24-1.2 2.816-2.528 2.816-.32 0-.56 0-.848-.032zM14.96 2.8c1.76 0 2.624.976 2.624 2.768v1.456c0 1.792-.864 2.768-2.624 2.768h-.832V14h-1.76V2.8h2.592zm0 1.6h-.832v3.792h.832c.56 0 .864-.256.864-1.056v-1.68c0-.8-.304-1.056-.864-1.056zm6.08 4.96v-1.6h2.464v3.552c0 1.792-.896 2.816-2.624 2.816-1.728 0-2.624-1.024-2.624-2.816V5.488c0-1.792.896-2.816 2.624-2.816 1.728 0 2.624 1.024 2.624 2.816v1.088H21.84v-1.2c0-.8-.352-1.104-.912-1.104s-.912.304-.912 1.104v6.048c0 .8.352 1.088.912 1.088s.912-.288.912-1.088V9.36h-.8z"
                />
            </g>
        </svg>
    ),
    jpeg: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">
            <g fill="none" fillRule="evenodd">
                <path fill="none" d="M0-1h24v20H0z" />
                <path
                    className="color"
                    fill="#37B"
                    d="M5.296 12.304h1.696V14H5.296v-1.696zM7.792 14v-1.6c.192.016.416.016.608.016.56 0 1.008-.208 1.008-1.072V2.8h1.76v8.416c0 2.24-1.2 2.816-2.528 2.816-.32 0-.56 0-.848-.032zM14.96 2.8c1.76 0 2.624.976 2.624 2.768v1.456c0 1.792-.864 2.768-2.624 2.768h-.832V14h-1.76V2.8h2.592zm0 1.6h-.832v3.792h.832c.56 0 .864-.256.864-1.056v-1.68c0-.8-.304-1.056-.864-1.056zm6.08 4.96v-1.6h2.464v3.552c0 1.792-.896 2.816-2.624 2.816-1.728 0-2.624-1.024-2.624-2.816V5.488c0-1.792.896-2.816 2.624-2.816 1.728 0 2.624 1.024 2.624 2.816v1.088H21.84v-1.2c0-.8-.352-1.104-.912-1.104s-.912.304-.912 1.104v6.048c0 .8.352 1.088.912 1.088s.912-.288.912-1.088V9.36h-.8z"
                />
            </g>
        </svg>
    ),
    xls: (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 25 20">
            <g fill="none" fillRule="evenodd">
                <path fill="none" d="M1-1h24v20H1z" />
                <path
                    className="color"
                    fill="#37B"
                    d="M4.376 12.304h1.696V14H4.376v-1.696zM11.592 2.8h1.632l-1.84 5.44L13.352 14h-1.856l-1.44-4.432L8.6 14H6.952L8.92 8.24 7.08 2.8h1.824l1.328 4.128 1.36-4.128zm2.64 11.2V2.8h1.76v9.6h2.896V14h-4.656zm5.2-8.512c0-1.792.88-2.816 2.592-2.816 1.712 0 2.592 1.024 2.592 2.816v.352h-1.664v-.464c0-.8-.32-1.104-.88-1.104s-.88.304-.88 1.104c0 2.304 3.44 2.736 3.44 5.936 0 1.792-.896 2.816-2.624 2.816-1.728 0-2.624-1.024-2.624-2.816v-.688h1.664v.8c0 .8.352 1.088.912 1.088s.912-.288.912-1.088c0-2.304-3.44-2.736-3.44-5.936z"
                />
            </g>
        </svg>
    ),
}


// WEBPACK FOOTER //
// ./src/utils/svgIcons.js